import Resource from "./resources";

const routerPermissionCheck = async (to) => {
  let can = true;
  if ('permissions' in to.meta) {
    for (let permission of to.meta.permissions) {
      const resourceName = permission.resource;
      const behaviors = permission.behaviors;
      can = can && await check(resourceName, behaviors, to.params);
    }
  }
  return can;
};


const check = (resourceName, behaviors, params) => {
  const resource = new Resource(resourceName, params);
  let permission = true;
  for (const behavior of behaviors) {
    if (resource.defaultPermissions.hasOwnProperty(behavior)) {
      if (resource.permissions.hasOwnProperty(behavior)) {
        permission = permission && resource.check(behavior);
      } else {
        console.info(behavior + " is unregistered.");
      }

    } else {
      throw "Not support this behavior.";
    }
    return permission;
  }
};

export const Plugins = {
  routerPermissionCheck,
  check,
};
